import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import {useNavigate} from "react-router-dom";
import commonClose from '../../assets/img/commonClose.png'
import {useTranslation} from "react-i18next";
import "../../css/mobile/MDeliveryPriceDetail.css";
import MsgSelectModal from "../web/modal/MsgSelectModal";
import MAddrBookPg from "../../page/mobile/MAddrBookPg";
import commonHether from "../../assets/img/commonHether.png";
import FedexLogo from "../../assets/img/FedexLogo.png";
import EmsLogo from "../../assets/img/EmsLogo.png";
import upsLogo from "../../assets/img/UpsLogo.png";
import kPacket from "../../assets/img/Kpacket.png";
import smallPacket from "../../assets/img/commonSmallPacket.png";
import SeaShipLogo from "../../assets/img/SeaShipLogo.png";
import CommonLoading from "../web/modal/CommonLoading";
import {BiCaretDown} from "react-icons/bi";
import SaveMsgModal from "../web/modal/SaveMsgModal";

function MDeliveryPriceDetail({closeDetail, paySeqnum, updatePayinfoList, deliveryDetailSt, deliveryDetailFalseFn, updateAppRecinfo, pathComponent, selectedShip}) {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const adminToken = localStorage.getItem('adminToken');

    const [isLoading, setIsLoading] = useState(false);
    const [isBtDisabled, setIsBtDisabled] = useState(false);
    const [isRecinfoBtLoading, setIsRecinfoBtLoading] = useState(false);
    const [isCustomBtLoading, setIsCustomBtLoading] = useState(false);

    const [contentsNameCount, setContentsNameCount] = useState(0);
    const [contentsSeqnum, setContentsSeqnum] = useState("");
    const [contentsName, setContentsName] = useState("");
    const [totalQuantity, setTotalQuantity] = useState("");
    const [contentsDollar, setContentsDollar] = useState('');
    const [contentsWon, setContentsWon] = useState('');

    const [contentsNameError, setContentsNameError] = useState(false);
    const [totalQuantityError, setTotalQuantityError] = useState(false);
    const [contentsDollarError, setContentsDollarError] = useState(false);
    const [contentsWonError, setContentsWonError] = useState(false);

    const [ctSaveDoneMessage, setCtSaveDoneMessage] = useState(false);
    const [ctSaveFailMessage, setCtSaveFailMessage] = useState(false);

    const customCurrency = ['KRW', 'USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD']
    const [selectedCurrency, setSelectedCurrency] = useState('USD');

    const [dollarShow, setDollarShow] = useState(false);
    const dollarRef = useRef(null);

    const toggleDollarShow = () => {
        setDollarShow(!dollarShow);
    };

    const selectChangeDollar = (e) => {
        setSelectedCurrency(e);
        setDollarShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dollarRef.current && !dollarRef.current.contains(event.target)) {
                setDollarShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const contentsNameLengthCheck = (e) => {
        setContentsNameCount(e.target.value.length);
    };
    const contentsNameInputRTCheck = (e) => {
        setContentsNameCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const validContentsName = ((e) => {
        const contentsNmRegex = /^[a-zA-Z ]{2,35}/; /*영문 2~25자*/
        if (!e.target.value || contentsNmRegex.test(e.target.value)) setContentsNameError(false);
        else setContentsNameError(true);
        setContentsName(e.target.value);
    })

    const validTotalQuantity = ((e) => {
        const totalQuantityRegex = /^\d{1,8}$/;
        const inputValue = e.target.value.replace(/,/g, '');

        if (!inputValue) {
            setTotalQuantityError(true);
            setTotalQuantity('');
        } else if (totalQuantityRegex.test(inputValue)) {
            setTotalQuantityError(false);
            setTotalQuantity(inputValue);
        } else {
            setTotalQuantityError(true);
        }
    })

    // 세관신고통화 셀렉트박스
    const formatCurrency = (value) => {
        // 1. 값이 없으면 빈 문자열 반환
        if (value === null || value === undefined || value === '') return '';
        // 2. [핵심] 들어온 값이 숫자일 수 있으므로 강제로 문자열로 변환
        const strValue = String(value);
        // 3. 소수점을 기준으로 분리 (이제 에러가 나지 않습니다)
        const parts = strValue.split('.');
        // 4. 정수 부분에만 콤마 추가
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // 5. 다시 합쳐서 반환
        return parts.join('.');
    };

    // 세관신고금액
    const validContentsDollar = ((e) => {
        // 콤마 제거 후 숫자만 추출
        const inputValue = e.target.value.replace(/,/g, '');

        // [변경] 정규식 수정
        // ^\d+ : 숫자로 시작
        // (\.\d{0,2})? : 소수점이 올 수 있고, 소수점 뒤에 최대 2자리까지 허용 (필요시 {0,4} 등으로 조절)
        // KRW 처럼 정수만 입력해도 통과됨
        const contentsDollarRegex = /^\d+(\.\d{0,2})?$/;

        if (!inputValue) {
            setContentsDollarError(true);
            setContentsDollar('');
        }
        // 입력값이 정규식과 맞거나, 마지막이 소수점('.')으로 끝나는 경우(입력 중) 허용
        else if (contentsDollarRegex.test(inputValue) || inputValue === '.') {
            setContentsDollarError(false);
            setContentsDollar(inputValue);
        } else {
            // 잘못된 입력이라도 지우거나 상태를 업데이트하지 않음 (사용자 경험 유지)
            // 혹은 에러 표시만 함
            // setContentsDollarError(true);
        }
    });

    const validContentsWon = ((e) => {
        const contentsWonRegex = /^\d{1,8}$/;
        const inputValue = e.target.value.replace(/,/g, '');
        if (!inputValue) {
            setContentsWonError(true);
            setContentsWon('');
        } else if (contentsWonRegex.test(inputValue)) {
            setContentsWonError(false);
            setContentsWon(inputValue);
        } else {
            setContentsWonError(true);
        }
    })

    const insrReset = (() => {
        setContentsWon('');
        setContentsWonError(false);
    })

    const contentsNameValidCheck = (e) => {
        validContentsName(e)
        contentsNameLengthCheck(e);
        contentsNameInputRTCheck(e)
    }

    const [insuranceStatus, setInsuranceStatus] = useState(false);
    const [memberInfo, setMemberInfo] = useState([]);

    const [payList, setPayList] = useState([{}]);
    const [appReqList, setAppReqList] = useState({});
    const [prodList, setProdList] = useState([]);
    const [packList, setPackList] = useState([]);
    const [shipInfoList, setShipInfoList] = useState({});
    const [orderSeqnum, setOrderSeqnum] = useState([]);
    const [appRecSeqnum, setAppRecSeqnum] = useState(0);

    const totalFedexExpense = payList[0]?.ttFedexPrice || 0
    const totalFedexEcoExpense = payList[0]?.ttFedexEcoPrice || 0
    const totalEmsExpense = payList[0]?.ttEmsPrice || 0
    const totalEmsPreExpense = payList[0]?.ttEmsPrePrice || 0
    const totalSeaExpense = payList[0]?.ttSeaPrice || 0
    const totalDomExpense = payList[0]?.ttDomPrice || 0
    const totalDhlExpense = payList[0]?.ttDhlPrice || 0
    const totalUpsExpense = payList[0]?.ttUpsPrice || 0
    const totalUpsEcoExpense = payList[0]?.ttUpsEcoPrice || 0
    const totalKpackExpense = payList[0]?.ttKPackPrice || 0
    const totalAirSExpense = payList[0]?.ttAirSPrice || 0

    const totalShipExpense = (
        totalFedexExpense !== 0 ? totalFedexExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
            totalFedexEcoExpense !== 0 ? totalFedexEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                totalEmsPreExpense !== 0 ? totalEmsPreExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                    totalEmsExpense !== 0 ? totalEmsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        totalSeaExpense !== 0 ? totalSeaExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                            totalDomExpense !== 0 ? totalDomExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                totalDhlExpense !== 0 ? totalDhlExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                    totalUpsExpense !== 0 ? totalUpsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                        totalUpsEcoExpense !== 0 ? totalUpsEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                            totalKpackExpense !== 0 ? totalKpackExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                                totalAirSExpense !== 0 ? totalAirSExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                                    0)

    const [taxid, setTaxid] = useState("");
    const [recname, setRecname] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [telnum, setTelnum] = useState("");

    const [deliveryChoiceError, setDeliveryChoiceError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [taxidError, setTaxidError] = useState("");
    const [recnameError, setRecnameError] = useState("");
    const [address1Error, setAddress1Error] = useState("");
    const [address2Error, setAddress2Error] = useState("");
    const [address3Error, setAddress3Error] = useState("");
    const [cityError, setCityError] = useState("");
    const [zipcodeError, setZipcodeError] = useState("");
    const [telnumError, setTelnumError] = useState("");

    const [recSaveDoneMessage, setRecSaveDoneMessage] = useState(false);
    const [recSaveFailMessage, setRecSaveFailMessage] = useState(false);

    const [nameInputCount, setNameInputCount] = useState(0);
    const [telnumInputCount, setTelnumInputCount] = useState(0);
    const [zipcodeInputCount, setZipcodeInputCount] = useState(0);
    const [address1InputCount, setAddress1InputCount] = useState(0);
    const [address2InputCount, setAddress2InputCount] = useState(0);
    const [address3InputCount, setAddress3InputCount] = useState(0);
    const [cityInputCount, setCityInputCount] = useState(0);

    const selectPayinfoDetail = (async () => {
        setIsLoading(true);
        try {
            await axios({
                method: 'get',
                url: '/order/selectTotalPayInfo/',
                headers: {
                    Authorization: LCAT ? LCAT : SSAT
                },
                params: {
                    seqNum: paySeqnum
                },
            })
                .then((response) => {
                    setPayList(response.data)
                    setAppReqList(response.data[0].appReqDTO)
                    setProdList(response.data[0].orderdtDTO.productsDTO)
                    setMemberInfo(response.data[0].orderdtDTO.memberDTO)
                    setPackList(response.data[0].packListDTO?.productsDTO)
                    setShipInfoList(response.data[0].shipInfoDTO)

                    setContentsNameCount(response.data[0].customsDTO.custContent.length)
                    setContentsSeqnum(response.data[0].customsDTO.seqNum)
                    setContentsName(response.data[0].customsDTO.custContent)
                    setTotalQuantity(response.data[0].customsDTO.custQty)
                    setSelectedCurrency(response.data[0].customsDTO.custCurrency)
                    setContentsDollar(response.data[0].customsDTO.custPrice)
                    setContentsWon(response.data[0].customsDTO.insrPrice)
                    setInsuranceStatus(response.data[0].customsDTO.insrFl)

                    setAppRecSeqnum(response.data[0].appRecDTO.seqnum)
                    const countryData = {
                        value: response.data[0].appRecDTO.countryDTO.countryCode,
                        label: response.data[0].appRecDTO.countryDTO.countryNm + '(' + response.data[0].appRecDTO.countryDTO.countryEngNm + ')'
                    };
                    setSelectedCountry(countryData)
                    setTaxid(response.data[0].appRecDTO.taxid);
                    setRecname(response.data[0].appRecDTO.recname)
                    setNameInputCount(response.data[0].appRecDTO.recname.length)
                    setTelnum(response.data[0].appRecDTO.telnum)
                    setTelnumInputCount(response.data[0].appRecDTO.telnum.length)
                    setZipcode(response.data[0].appRecDTO.zipcode)
                    setZipcodeInputCount(response.data[0].appRecDTO.zipcode.length)
                    setAddress1(response.data[0].appRecDTO.address1)
                    setAddress1InputCount(response.data[0].appRecDTO.address1.length)
                    setAddress2(response.data[0].appRecDTO.address2)
                    setAddress2InputCount(response.data[0].appRecDTO.address2.length)
                    setAddress3(response.data[0].appRecDTO.address3)
                    setAddress3InputCount(response.data[0].appRecDTO.address3.length)
                    setCity(response.data[0].appRecDTO.city)
                    setCityInputCount(response.data[0].appRecDTO.city.length)

                    setOrderSeqnum(response.data[0].orderdtDTO.seqnum)
                })
        } catch (error) {
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    })

    useEffect(() => {
        selectPayinfoDetail();
    }, [])

    const validation = () => {
        if (!contentsName) setContentsNameError(true);
        if (!totalQuantity) setTotalQuantityError(true);
        if (!contentsDollar) setContentsDollarError(true);
        if (insuranceStatus && !contentsWon) setContentsWonError(true);
        return !!(contentsName && totalQuantity && contentsDollar && (!insuranceStatus || (insuranceStatus && contentsWon)));
    }

    const modifyCustoms = (async () => {
        if (isBtDisabled) return;
        setIsBtDisabled(true);
        setIsCustomBtLoading(true);

        try {
            await axios({
                method: 'post',
                url: '/order/modifyCustoms/',
                data: {
                    seqNum: contentsSeqnum,
                    custContent: contentsName,
                    custQty: totalQuantity,
                    custCurrency: selectedCurrency,
                    custPrice: contentsDollar,
                    insrFl: insuranceStatus,
                    insrPrice: contentsWon === '' ? 0 : contentsWon
                },
                headers: {
                    Authorization: LCAT ? LCAT : SSAT
                },
                params: {
                    paySeqnum: paySeqnum,
                }
            })
                .then((response)=> {
                    setCtSaveDoneMessage(true);
                    setTimeout(() => setCtSaveDoneMessage(false), 1500);
                    updatePayinfoList(response.data[0]);
                    setPayList(response.data)
                    setIsBtDisabled(false);
                    setIsCustomBtLoading(false);
                })
                .catch((error)=> {
                    console.error(error)
                    setCtSaveFailMessage(true);
                    setTimeout(() => setCtSaveFailMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsCustomBtLoading(false);
                })
        } catch (error) {
            console.error(error)
            setCtSaveFailMessage(true);
            setTimeout(() => setCtSaveFailMessage(false), 1500);
            setIsBtDisabled(false);
            setIsCustomBtLoading(false);
        } finally {
            setIsBtDisabled(false);
            setIsCustomBtLoading(false);
        }
    })

    const valiAndCustomSave = async (e) => {
        validation();
        if (validation()) {
            await modifyCustoms(e);
        }
    }

    // 여기서부터 국가 커스텀셀렉트
    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({value: '', label: t(`ordCrLabel`)});
    const [countryShow, setCountryShow] = useState(false);
    const [filteredCountryList, setFilteredCountryList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const countryRef = useRef(null);

    const toggleCountryShow = () => {
        setCountryShow(prev => !prev);
    };

    const handleCountryChange = (country, event) => {
        event.stopPropagation();
        setSelectedCountry(country);
        setSearchKeyword(country.label);
        setCountryShow(false);
    };

    const countryNameMapping = {
        'USA': 'United States of America',
        '터키': '튀르키예',
    };

    const handleCountrySearch = (event) => {
        const keyword = event.target.value;
        setSearchKeyword(keyword);

        const mappedKeyword = countryNameMapping[keyword.toUpperCase()] || countryNameMapping[keyword] || keyword;

        const filteredCountries = countryList.filter((country) =>
            country.label.toLowerCase().includes(mappedKeyword.toLowerCase())
        );

        setFilteredCountryList(filteredCountries);

        if (!keyword) {
            setSelectedCountry({ value: '', label: t(`ordCrLabel`) });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setCountryShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const selectAllCountry = () => {
        axios.get('/order/selectCountry')
            .then(response => {
                const countries = response.data.map(country => ({
                    value: country.countryCode,
                    label: `${country.countryNm}(${country.countryEngNm})`
                })).sort((a, b) => a.label.localeCompare(b.label));

                setCountryList(countries);
                setFilteredCountryList(countries);
            })
            .catch(error => {
                console.log(error);
            });
    };

    useEffect(() => {
        selectAllCountry();
    }, [])

    const postOffice = selectedShip === 'EMS' || selectedShip === 'EMSP' ||
        selectedShip === 'K-Packet' || selectedShip === 'Small-Packet' || selectedShip === 'SEA';
    const SpecialDelivery = selectedShip === 'FedEx' ||selectedShip === 'FedEx-E' ||
        selectedShip === 'UPS' || selectedShip === 'UPS-E' || selectedShip === 'DHL';
    const domesticDelivery = selectedShip === '국내배송';

    const address1Length = postOffice ? 200 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address2Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address3Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const cityLength = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;

    const validTextTaxid = ((e) => {
        let taxidRegex;
        taxidRegex = /^[a-zA-Z0-9\s\-.,]{2,25}$/; /*2~25자*/
        if (!e.target.value || taxidRegex.test(e.target.value)) setTaxidError(false);
        else setTaxidError(true);
        setTaxid(e.target.value);
    })
    const validTextRecname = ((e) => {
        const recnameRegex = /^[a-zA-Z ]{2,35}/; /*영문 2~25자*/
        if (!e.target.value || recnameRegex.test(e.target.value)) setRecnameError(false);
        else setRecnameError(true);
        setRecname(e.target.value);
    })
    const validTextAddr1 = ((e) => {
        const Addr1Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address1Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr1Regex.test(e.target.value)) setAddress1Error(false);
        else setAddress1Error(true);
        setAddress1(e.target.value);
    })
    const validTextAddr2 = ((e) => {
        const Addr2Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address2Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr2Regex.test(e.target.value)) setAddress2Error(false);
        else setAddress2Error(true);
        setAddress2(e.target.value);
    })
    const validTextAddr3 = ((e) => {
        const Addr3Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address3Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr3Regex.test(e.target.value)) setAddress3Error(false);
        else setAddress3Error(true);
        setAddress3(e.target.value);
    })
    const validTextCity = ((e) => {
        const cityRegex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${cityLength}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || cityRegex.test(e.target.value)) setCityError(false);
        else setCityError(true);
        setCity(e.target.value);
    })
    const validTextZipcode = ((e) => {
        const zipcodeRegex = /^[a-zA-Z\d- ]{3,10}$/; // 암호화 // 영문 또는 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || zipcodeRegex.test(e.target.value)) setZipcodeError(false);
        else setZipcodeError(true);
        setZipcode(e.target.value);
    })
    const validTextTelnum = ((e) => {
        const telnumRegex = /^[\d-]{5,15}$/; // 암호화 // 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || telnumRegex.test(e.target.value)) setTelnumError(false);
        else setTelnumError(true);
        setTelnum(e.target.value);
    })

    const nameInputLengthCheck = (e) => {
        setNameInputCount(e.target.value.length);
    };

    const telnumInputLengthCheck = (e) => {
        setTelnumInputCount(e.target.value.length);
    };

    const zipcodeInputLengthCheck = (e) => {
        setZipcodeInputCount(e.target.value.length);
    };

    const address1InputLengthCheck = (e) => {
        setAddress1InputCount(e.target.value.length);
    };

    const address2InputLengthCheck = (e) => {
        setAddress2InputCount(e.target.value.length);
    };

    const address3InputLengthCheck = (e) => {
        setAddress3InputCount(e.target.value.length);
    };

    const cityInputLengthCheck = (e) => {
        setCityInputCount(e.target.value.length);
    };

    const nameInputRTCheck = (e) => {
        setNameInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const telnumInputRTCheck = (e) => {
        setTelnumInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const zipcodeInputRTCheck = (e) => {
        setZipcodeInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address1InputRTCheck = (e) => {
        setAddress1InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address2InputRTCheck = (e) => {
        setAddress2InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address3InputRTCheck = (e) => {
        setAddress3InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const cityInputRTCheck = (e) => {
        setCityInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const nameValid = (e) => {
        validTextRecname(e)
        nameInputLengthCheck(e);
        nameInputRTCheck(e)
    }

    const getMaxLengthByPhoneCountry = () => {
        if (selectedCountry.value === "US") return 10;
        return 15;
    };

    const currentMaxLengthPhoneDisplay = `${getMaxLengthByPhoneCountry()}`;

    const telnumValid = (e) => {
        const { value } = e.target;

        //미국 숫자만 10자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,10}$/.test(value)) {
                validTextTelnum(e);
                telnumInputLengthCheck(e);
                telnumInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 15) {
            validTextTelnum(e)
            telnumInputLengthCheck(e);
            telnumInputRTCheck(e)
        }
    }

    const getMaxLengthByCountry = () => {
        if (selectedCountry.value === "US") return 5; // 미국
        if (selectedCountry.value === "CA") return 6; // 캐나다
        return 10;
    };

    const currentMaxLengthDisplay = `${getMaxLengthByCountry()}`;

    const zipcodeValid = (e) => {
        const { value } = e.target;

        //미국 숫자만 5자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,5}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        //캐나다 문자숫자 6자리
        if (selectedCountry.value === "CA") {
            if (/^[a-zA-Z0-9]{0,6}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 10) {
            validTextZipcode(e);
            zipcodeInputLengthCheck(e);
            zipcodeInputRTCheck(e);
        }
    }

    const address1Valid = (e) => {
        validTextAddr1(e)
        address1InputLengthCheck(e);
        address1InputRTCheck(e)
    }

    const address2Valid = (e) => {
        validTextAddr2(e)
        address2InputLengthCheck(e);
        address2InputRTCheck(e)
    }

    const address3Valid = (e) => {
        validTextAddr3(e)
        address3InputLengthCheck(e);
        address3InputRTCheck(e)
    }

    const cityValid = (e) => {
        validTextCity(e)
        cityInputLengthCheck(e);
        cityInputRTCheck(e)
    }

    const recValidation = () => {
        let isValid = true;

        setTaxidError(false);
        setRecnameError(false);
        setAddress1Error(false);
        setCityError(false);
        setZipcodeError(false);
        setTelnumError(false);
        setCountryError(false);

        if (selectedCountry.value === "ID" && selectedShip !== 'EMS' && !taxid) {
            setTaxidError(true);
            isValid = false;
        }
        if (selectedCountry.value === t(`ordCrLabel`) || !selectedCountry) {
            setCountryError(true);
            isValid = false;
        }
        if (!recname) {
            setRecnameError(true);
            isValid = false;
        }
        if (!address1) {
            setAddress1Error(true);
            isValid = false;
        }
        if (!city) {
            setCityError(true);
            isValid = false;
        }
        if (!zipcode) {
            setZipcodeError(true);
            isValid = false;
        }
        if (!telnum) {
            setTelnumError(true);
            isValid = false;
        }
        return isValid;
    };

    const valiAndApprecSave = async (e) => {
        const isValid = recValidation();
        if (isValid) {
            await modifyApprec(e);
        }
    };

    const modifyApprec = (async () => {
        if (isBtDisabled) return;
        setIsBtDisabled(true);
        setIsRecinfoBtLoading(true);
        try {
            await axios({
                method: 'post',
                url: '/order/modifyApprec/',
                data: {
                    seqnum: appRecSeqnum,
                    crCode: selectedCountry.value,
                    taxid: taxid,
                    recname: recname,
                    telnum: telnum,
                    zipcode: zipcode,
                    address1: address1,
                    address2: address2,
                    address3: address3,
                    city: city,
                },
                headers: {
                    Authorization: LCAT ? LCAT : SSAT
                },
                params: {
                    mbNum: memberInfo.mbNum
                }
            })
                .then((response)=> {
                    if (pathComponent === "/UserMyPg" || pathComponent === "/btcorpad") {
                        updateAppRecinfo(response.data);
                    }
                    setRecSaveDoneMessage(true);
                    setTimeout(() => setRecSaveDoneMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsRecinfoBtLoading(false);
                })
                .catch((error)=> {
                    console.log("수취인정보 에러 : ", error)
                    setRecSaveFailMessage(true);
                    setTimeout(() => setRecSaveFailMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsRecinfoBtLoading(false);
                })
        } catch (error) {
            console.log("수취인정보 에러 : ", error)
            setRecSaveFailMessage(true);
            setTimeout(() => setRecSaveFailMessage(false), 1500);
            setIsBtDisabled(false);
            setIsRecinfoBtLoading(false);
        } finally {
            setIsBtDisabled(false);
            setIsRecinfoBtLoading(false);
        }
    })

    const [deliveryDetailAddrSt, setDeliveryDetailAddrSt] = useState(false);

    const deliveryDetailAddrFalseFn = (() => {
        setDeliveryDetailAddrSt(false);
    })

    const addrChoiceData = ((addrSeqnum) => {
        axios({
            method: 'get',
            url: '/member/choiceAddrInfo',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                seqnum: addrSeqnum
            }
        })
            .then((response) => {
                const countryData = {
                    value: response.data.countryDTO.countryCode,
                    label: response.data.countryDTO.countryNm + '(' + response.data.countryDTO.countryEngNm + ')'
                };
                setSelectedCountry(countryData)
                setTaxid(response.data.taxid);
                setRecname(response.data.recname)
                setAddress1(response.data.address1)
                setAddress2(response.data.address2)
                setAddress3(response.data.address3)
                setCity(response.data.city)
                setZipcode(response.data.zipcode)
                setTelnum(response.data.telnum)
                setNameInputCount(response.data.recname.length)
                setAddress1InputCount(response.data.address1.length)
                setAddress2InputCount(response.data.address2.length)
                setAddress3InputCount(response.data.address3.length)
                setCityInputCount(response.data.city.length)
                setZipcodeInputCount(response.data.zipcode.length)
                setTelnumInputCount(response.data.telnum.length)
                deliveryDetailAddrFalseFn();
                fieldErrorClean();
            })
    })

    const fieldErrorClean = () => {
        setTaxidError(false);
        setRecnameError(false)
        setTelnumError(false);
        setZipcodeError(false);
        setAddress1Error(false);
        setAddress2Error(false);
        setAddress3Error(false);
        setCityError(false);
    }

    const [deliveryDetailPayMove, setDeliveryDetailPayMove] = useState(false);
    const deliveryDetailPayMsg1 = t(`dpdMdMsg1`);
    const deliveryDetailPayMsg2 = t(`dpdMdMsg2`);

    const moveDeliveryPay = (() => {
        if (payList.length > 0) {
            navigate(`/UserMyOrderPg/${payList[0].orderdtDTO.orderNumber}`);
        }
    })

    const MAddrAddInput = (isEssential,
                           title,
                           value,
                           maxLength,
                           ref,
                           onChange,
                           showLength,
                           length,
                           lengthLimit,
                           disabled) => {
        const numericTitles = [t('modNbInfo5'), t('dpdHeader5'), t('dpdHeader6') + '(USD)', t('dpdHeader8') + '(KRW)'];
        const isNumericInput = numericTitles.includes(title);

        return (
            <div className="m-a-delivery-price-input-box wd-100pc">
                {value.length > 0 &&
                    <div className="m-a-delivery-price-input-title">
                        {isEssential &&
                            <div className="m-a-delivery-price-input-essential">* &nbsp;</div>
                        }
                        {title}
                    </div>
                }
                {value.length === 0 && isEssential &&
                    <div className="m-a-delivery-price-input-essential p-l-5">* &nbsp;</div>}
                        <input className="m-a-delivery-price-input wd-80pc"
                               type={isNumericInput ? "tel" : "text"}
                               inputMode={isNumericInput ? "numeric" : undefined}
                               pattern={isNumericInput ? "[0-9]*" : undefined}
                               value={value} maxLength={maxLength}
                               ref={ref}
                               placeholder={value.length === 0 ? title : ''}
                               onChange={onChange}
                               disabled={disabled}/>
                {showLength &&
                    <div className="m-a-delivery-price-input-text wd-20pc text-right p-r-5">
                        <div className="m-a-delivery-price-input-text highlight">{length}</div>
                        / {lengthLimit}
                    </div>
                }
            </div>
        )
    }

    const [doneCopyMsg, setDoneCopyMsg] = useState(null);
    const [doneCopySt, setDoneCopySt] = useState(false);
    const copyOutWayNum = async () => {
        const textToCopy = shipInfoList.outWayNum || '';

        if (!textToCopy) return;

        try {
            // 클립보드에 텍스트 복사
            await navigator.clipboard.writeText(textToCopy);
            setDoneCopyMsg("복사완료!");
            setDoneCopySt(true);
            setTimeout(() => setDoneCopySt(false), 2000);
        } catch (err) {
            console.error('복사 실패:', err);
            setDoneCopyMsg("복사 실패");
            setDoneCopySt(true);
            setTimeout(() => setDoneCopySt(false), 2000);
        }
    }

    // 임시비활성화
    const disableSt = true;

    return (
        <div className="m-a-delivery-price-detail-background font-t-cont">
            <div className="m-a-delivery-price-detail-container">
                <div className={'m-a-delivery-price-detail-header'}>
                    <div className={'m-a-delivery-price-detail-header-title font-t-title'}>
                        {deliveryDetailSt ? t(`dpdHeader1`) : t(`dpdHeader2`)}
                    </div> {/*배송비상세*/} {/*패키지정보*/}
                    <img className="m-a-delivery-price-detail-header-icon" onClick={deliveryDetailSt ? deliveryDetailFalseFn : closeDetail} src={commonClose} alt={''}/>
                </div>
                <div className="m-a-delivery-price-detail-body">
                    <div className={'m-a-delivery-price-detail-table-title'}>
                        <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                        {t(`modRefInfo`)} {/*수취인정보*/}
                        <span className={'dt-price-primary'}>({t(`essential`)})</span> {/*필수*/}
                    </div>
                    <div className={'m-a-delivery-price-add-content'}>
                        {/*국가+주소록 임시비활성화*/}
                        <div className="m-a-delivery-price-add-country-select-box">
                            <div ref={countryRef} className="ht-45 wd-80pc c-point position-relative" onClick={!disableSt ? toggleCountryShow : undefined}>
                                <div className="order-rec-country-input display-flex flex-row wd-100pc ht-100pc">
                                    {selectedCountry.value ? (
                                        <div className="wd-15pc text-center p-l-5 p-t-10">
                                            <div className={`m-l-6 font-s-20 fi fi-${selectedCountry.value.toLowerCase()}`} />
                                        </div>
                                    ) : (
                                        <div className="wd-15pc text-center p-l-5 p-t-10">
                                            <div className="wd-29 ht-22 text-center font-s-12 m-0-a country-select-flag">?</div>
                                        </div>
                                    )}
                                    <input className="country-select-in-input wd-100pc ht-100pc c-point font-s-12 p-l-15"
                                           type="text" placeholder={t(`modSmallMenu3-1`)} autoComplete="nope"
                                           value={searchKeyword || (selectedCountry.value ? selectedCountry.label : '') || (selectedCountry.value ? selectedCountry.label : '')}
                                           onChange={handleCountrySearch}
                                    disabled={disableSt}/>
                                    <i className="wd-15pc text-center align-center-c font-s-20 p-b-2 font-c-darkgrey">
                                        <BiCaretDown />
                                    </i>
                                </div>
                                {countryShow && !disableSt && (
                                    <div className="country-select-data wd-100pc position-absolute m-t-5">
                                        <div className="country-select-data-child">
                                        {filteredCountryList.map((country, index) => (
                                            <div className="selectCrListBt display-flex c-point p-t-10 p-b-10 p-l-20" key={index}
                                                 onClick={(event) => handleCountryChange(country, event)}>
                                                <div className={`font-s-17 m-r-8 fi fi-${country.value.toLowerCase()}`}></div>
                                                <p className="font-s-14">{country.label}</p>
                                            </div>
                                        ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button className="admin-btn-A wd-20pc ht-45 font-s-13" onClick={() => setDeliveryDetailAddrSt(true)}
                                    disabled={disableSt || (!adminToken && payList[0].payStatus !== "PS0")}>
                                {t(`rmmBookBt`)}
                            </button> {/*주소록 버튼*/}
                        </div>
                        {countryError && disableSt &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {t(`recCrErr`)}
                                </div>
                            </div>
                        }
                        {MAddrAddInput(true,
                            t(`joinLabel5`),
                            recname,
                            25,
                            null,
                            nameValid,
                            selectedCountry.value !== "KR", nameInputCount, 25,
                            !adminToken && payList[0].payStatus !== "PS0"
                        )}
                        {selectedCountry.value !== "KR" && recnameError &&
                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {t(`recNmErr`)}
                                </div>
                            </div>
                        }
                        {/*연락처*/}
                        {MAddrAddInput(true,
                            t(`modNbInfo5`),
                            telnum,
                            15,
                            null,
                            telnumValid,
                            selectedCountry.value !== "KR", telnumInputCount, currentMaxLengthPhoneDisplay,
                            !adminToken && payList[0].payStatus !== "PS0"
                        )}
                        {selectedCountry.value !== "KR" && telnumError &&
                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {t("recTellErr")}
                                </div>
                            </div>
                        }
                        {/*우편번호*/}
                        {MAddrAddInput(true,
                            t(`modNbInfo8`),
                            zipcode,
                            10,
                            null,
                            zipcodeValid,
                            true, zipcodeInputCount, currentMaxLengthDisplay,
                            !adminToken && payList[0].payStatus !== "PS0"
                        )}
                        {zipcodeError &&
                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {t("recZipErr")}
                                </div>
                            </div>
                    }
                    {selectedCountry.value === "ID" ?
                        <>
                            {MAddrAddInput(true,
                                'Tax ID',
                                    taxid,
                                    25,
                                    null,
                                    validTextTaxid,
                                    false, 0, 0,
                                    !adminToken && payList[0].payStatus !== "PS0"
                                )}
                            </>
                            : null}
                        {taxidError &&
                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {t(`recTaxIdErr`)}
                                </div>
                            </div>
                    }
                    {MAddrAddInput(true,
                        selectedCountry.value === "KR" ? t(`modSmallMenu14`) : t(`modSmallMenu7`),
                        address1,
                        selectedCountry.value !== "KR" ? address1Length : null,
                            null,
                            address1Valid,
                            selectedCountry.value !== "KR", address1InputCount, address1Length,
                            !adminToken && payList[0].payStatus !== "PS0"
                        )}
                        {selectedCountry.value !== "KR" && address1Error &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                <div className="m-a-error-msg font-t-cont font-s-12">
                                    {`${t("recAddrErr1")} 2~${address1Length}${t("recAddrErr2")}`}
                                </div>
                            </div>
                        }
                        {selectedCountry.value !== "KR" && (
                            <>
                            {/*주소2*/}
                            {MAddrAddInput(false,
                                t(`modSmallMenu8`),
                                address2,
                                address2Length,
                                null,
                                address2Valid,
                                true, address2InputCount, address2Length,
                                !adminToken && payList[0].payStatus !== "PS0"
                            )}
                            {address2Error &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {`${t("recAddrErr1")} 2~${address2Length}${t("recAddrErr2")}`}
                                    </div>
                                </div>
                            }
                            {/*주소3*/}
                            {MAddrAddInput(false,
                                t(`modSmallMenu9`),
                                address3,
                                address3Length,
                                null,
                                address3Valid,
                                true, address3InputCount, address3Length,
                                !adminToken && payList[0].payStatus !== "PS0"
                            )}
                            {address3Error &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {`${t("recAddrErr1")} 2~${address3Length}${t("recAddrErr2")}`}
                                    </div>
                                </div>
                            }
                            {/*도시명*/}
                            {MAddrAddInput(true,
                                t(`modSmallMenu10`),
                                city,
                                cityLength,
                                null,
                                cityValid,
                                true, cityInputCount, cityLength,
                                !adminToken && payList[0].payStatus !== "PS0"
                            )}
                            {cityError &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {`${t("recAddrErr1")} 2~${cityLength}${t("recAddrErr2")}`}
                                    </div>
                                </div>
                        }
                                {recSaveDoneMessage &&
                                    <div className="m-a-error-msg-container wd-100pc m-t-10"
                                         style={{justifyContent: "center"}}>
                                        <div className="m-a-error-msg font-t-cont font-s-13">
                                            {t(`dpdSvMsg1`)} &#128521;
                                        </div>
                                    </div>
                                }
                                {recSaveFailMessage &&
                                    <div className="m-a-error-msg-container wd-100pc m-t-10"
                                         style={{justifyContent: "center"}}>
                                        <div className="m-a-error-msg font-t-cont font-s-13">
                                            {t(`dpdSvMsg2`)} &#128514;
                                        </div>
                                    </div>
                                }
                    </>
                    )}
                    <style>
                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                    </style>
                    <button className="admin-btn-A wd-80 ht-35 font-s-12 m-t-10"
                                onClick={valiAndApprecSave}
                                disabled={isBtDisabled || (!adminToken && payList[0].payStatus !== "PS0")}>
                            {isRecinfoBtLoading ? (
                                <div className="smallSpinner m-0-a"></div>
                            ) : (
                                <div>{t(`saveBt`)}</div>
                            )}
                        </button>
                    </div>
                </div>
                {!payList[0].ttDomPrice > 0 &&
                    <div className={'m-a-delivery-price-detail-body'}>
                        <div className={'m-a-delivery-price-detail-table-title'}>
                            <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                            {t(`dpdHeader3`)} {/*세관신고 & 보험*/}
                            <span className="dt-price-primary">({t(`essential`)})</span> {/*필수*/}
                        </div>
                        <div className={'m-a-delivery-price-add-content'}>
                            {MAddrAddInput(true,
                                t(`dpdHeader4`),
                                contentsName,
                                50,
                                null,
                                contentsNameValidCheck,
                                true, contentsNameCount, 50,
                                !adminToken && payList[0].payStatus !== "PS0"
                            )}
                            {contentsNameError &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {t(`dpdErr1`)}
                                    </div>
                                </div>
                            }
                            {MAddrAddInput(true,
                                t(`dpdHeader5`),
                                totalQuantity,
                                5,
                                null,
                                validTotalQuantity,
                                false, 0, 0,
                                !adminToken && payList[0].payStatus !== "PS0")}
                            {totalQuantityError &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {t(`dpdErr2`)}
                                    </div>
                                </div>
                            }

                            <div className="display-flex wd-100pc" style={{alignItems: "flex-end"}}>
                                {/*통화 셀렉트박스*/}
                                <div ref={dollarRef} className="ht-45 position-relative m-r-5" style={{width: "20%"}}>
                                    <button className="selectParentBt wd-100pc ht-100pc" onClick={toggleDollarShow}>
                                        <p style={{
                                            margin: "0",
                                            fontSize: "12px",
                                            padding: "0 5px"
                                        }}>{selectedCurrency}</p>
                                    </button>
                                    {dollarShow ?
                                        <div style={{
                                            position: "absolute",
                                            width: "200%",
                                            border: "solid",
                                            borderWidth: "thin 1px",
                                            borderColor: "lightgray",
                                            zIndex: 999,
                                            marginTop: "10px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                        }}>
                                            {customCurrency.map((dollar, index) => (
                                                <div className="selectChildBt user-center pd10 c-point font-s-12"
                                                     key={index}
                                                     onClick={() => selectChangeDollar(dollar)}
                                                     style={{
                                                         zIndex: 99,
                                                     }}>{dollar}</div>
                                            ))}
                                        </div>
                                        :
                                        null
                                    }
                                </div>

                                <div style={{width: "80%"}}>
                                    {MAddrAddInput(true,
                                        t(`dpdHeader6`),
                                        formatCurrency(contentsDollar),
                                        20,
                                        null,
                                        validContentsDollar,
                                        false, 0, 0,
                                        !adminToken && payList[0].payStatus !== "PS0")}
                                </div>
                            </div>

                            {contentsDollarError &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {t(`dpdErr3`)}
                                    </div>
                                </div>
                            }
                            <div className="m-a-delivery-price-divider"/>
                            <div className={'m-a-delivery-price-sub-title'}>{t(`dpdHeader7`)}</div>
                            <div className={'m-a-delivery-price-row'}>
                                <div className={'m-a-delivery-price-row-item'}>
                                    <input className="radioButton" type="radio" name="insurance"
                                           checked={!insuranceStatus}
                                           onChange={() => setInsuranceStatus(false)}
                                           onClick={insrReset}
                                           style={{height: "15px"}}
                                           disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                    {t(`dpdLabel1`)}
                                </div>
                                <div className={'m-a-delivery-price-row-item'}>
                                    <input className="radioButton" type="radio" name="insurance"
                                           checked={insuranceStatus}
                                           onChange={() => setInsuranceStatus(true)}
                                           style={{height: "15px"}}
                                           disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                    {t(`dpdLabel2`)}
                                </div>
                            </div>
                            {MAddrAddInput(false,
                                t(`dpdHeader8`) + '(KRW)',
                                contentsWon ? parseInt(contentsWon).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '',
                                8,
                                null,
                                validContentsWon,
                                false, 0, 0,
                                !insuranceStatus || (!adminToken && payList[0].payStatus !== "PS0"))}
                            {contentsWonError &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                        {t(`dpdErr4`)}
                                    </div>
                                </div>
                            }
                            {ctSaveDoneMessage &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5"
                                     style={{justifyContent: "center"}}>
                                    <div className="m-a-error-msg font-t-cont font-s-13">
                                        {t(`dpdSvMsg1`)} &#128521;
                                    </div>
                                </div>
                            }
                            {ctSaveFailMessage &&
                                <div className="m-a-error-msg-container wd-100pc m-t-5"
                                     style={{justifyContent: "center"}}>
                                    <div className="m-a-error-msg font-t-cont font-s-13">
                                        {t(`dpdSvMsg2`)} &#128514;
                                    </div>
                                </div>
                            }
                            <style>
                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                            </style>
                            <button className="admin-btn-A wd-80 ht-35 font-s-12 m-t-10" onClick={valiAndCustomSave}
                                    disabled={isBtDisabled || (!adminToken && payList[0].payStatus !== "PS0")}>
                                {isCustomBtLoading ? (
                                    <div className="smallSpinner m-0-a"></div>
                                ) : (
                                    <div>{t(`saveBt`)}</div>
                                )}
                            </button>
                            {/*저장*/}
                        </div>
                    </div>
                }
                <div className={'m-a-delivery-price-detail-body'}>
                    <div className={'m-a-delivery-price-detail-table-title'}>
                        <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                        {t(`dpdHeader9`)} {/*무게정보*/}
                    </div>
                    <div className={'m-a-delivery-price-add-content'}>
                        <div className={'m-a-delivery-price-row-space-between'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`realWt`)}</div>
                            <div className={'m-a-delivery-price-row-space-between-item'}>{shipInfoList.weight}kg</div>
                        </div>
                        <div className={'m-a-delivery-price-row-space-between'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>
                                {t(`volWt`)}[{shipInfoList.wid}cm*{shipInfoList.ver}cm*{shipInfoList.hei}cm]
                            </div>
                            <div className={'m-a-delivery-price-row-space-between-item'}>
                                {payList[0]?.ttFedexPrice > 0 ? shipInfoList.fedexWeight
                                    : payList[0]?.ttUpsPrice > 0 ? shipInfoList.upsWeight
                                        : payList[0]?.ttEmsPrice > 0 ? shipInfoList.emsWeight
                                            : payList[0]?.ttSeaPrice > 0 ? shipInfoList.seaWeight
                                                : (
                                                    payList[0]?.orderdtDTO?.shipco === "FedEx" || payList[0]?.orderdtDTO?.shipco === "FedEx-E"
                                                        ? shipInfoList.fedexWeight
                                                        : payList[0]?.orderdtDTO?.shipco === "UPS" || payList[0]?.orderdtDTO?.shipco === "UPS-E"
                                                            ? shipInfoList.upsWeight
                                                            : payList[0]?.orderdtDTO?.shipco === "EMS"
                                                                ? shipInfoList.emsWeight
                                                                : payList[0]?.orderdtDTO?.shipco === "EMSP"
                                                                    ? shipInfoList.emsPreWeight
                                                                    : payList[0]?.orderdtDTO?.shipco === "SEA"
                                                                        ? shipInfoList.seaWeight
                                                                        : payList[0]?.orderdtDTO?.shipco === "Small-Packet"
                                                                            ? shipInfoList.airSWeight
                                                                            : payList[0]?.orderdtDTO?.shipco === "K-Packet"
                                                                                ? shipInfoList.kpackWeight
                                                                                : ""
                                                )
                                }kg
                            </div>
                        </div>


                        {payList[0]?.ttFedexPrice > 0 ?
                        <div className={'m-a-delivery-price-row-space-between'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>FedEx {t(`appWt`)}</div>
                            <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.fedexApyWeight}kg</div>
                        </div>
                            :
                            null
                        }

                        {payList[0]?.ttFedexEcoPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>FedEx-E {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.fedexEcoApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttUpsPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>UPS {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.upsApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttUpsEcoPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>UPS-E {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.upsEcoApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttEmsPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>EMS {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.emsApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttEmsPrePrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>EMSP {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.emsPreApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttKPackPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>K-Packet {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.kpackApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttAirSPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>Small-Packet {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.airSApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttSeaPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>SEA {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.seaApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttDomPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>{t('ugCont11')} {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.domeApyWeight}kg</div>
                            </div>
                            :
                            null
                        }

                        {payList[0]?.ttDhlPrice > 0 ?
                            <div className={'m-a-delivery-price-row-space-between'}>
                                <div className={'m-a-delivery-price-row-space-between-item'}>DHL {t(`appWt`)}</div>
                                <div className={'m-a-delivery-price-row-space-between-item primary'}>{shipInfoList.dhlApyWeight}kg</div>
                            </div>
                            :
                            null
                        }


                    </div>
                </div>
                <div className={'m-a-delivery-price-divider'}/>
                <div className={'m-a-delivery-price-detail-body'}>
                    <div className={'m-a-delivery-price-detail-table-title'}>
                        <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                        {t(`modPlHeader3`)} {/*해외배송비*/}
                    </div>
                    <div className={'m-a-delivery-price-add-content'}>
                        {/*FedEx*/}
                        {payList[0]?.ttFedexPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame'>
                                    <img className='m-a-delivery-price-delivery-agency' src={FedexLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`fuelScg`)} {/*유류할증료*/}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`deliveryFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`oTx1`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`etcArea`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {totalFedexExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*FedEx-E*/}
                        {payList[0]?.ttFedexEcoPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame'>
                                    <img className='m-a-delivery-price-delivery-agency' src={FedexLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`fuelScg`)} {/*유류할증료*/}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexEcoFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`deliveryFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexEcoAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`oTx1`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexEcoCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`etcArea`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.fedexInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {totalFedexEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*UPS*/}
                        {payList[0]?.ttUpsPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame' style={{padding: "3px"}}>
                                    <img className='m-a-delivery-price-delivery-agency' src={upsLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`fuelScg`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`etcArea`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.upsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalUpsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*UPS-E*/}
                        {payList[0]?.ttUpsEcoPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame' style={{padding: "3px"}}>
                                    <img className='m-a-delivery-price-delivery-agency' src={upsLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`fuelScg`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsEcoFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsEcoAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsEcoCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`etcArea`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.upsOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.upsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalUpsEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*/!*DHL*!/*/}
                        {/*{payList[0]?.ttDhlPrice > 0 && (*/}
                        {/*    <div className={'m-a-delivery-price-add-content flex-start'}>*/}
                        {/*        <div className='m-a-delivery-price-delivery-agency-frame'>*/}
                        {/*            <img className='m-a-delivery-price-delivery-agency'*/}
                        {/*                 style={{width: "60px", height: "40px"}} src={dhlLogo} alt={''}/>*/}
                        {/*        </div>*/}
                        {/*        <div className={'m-a-delivery-price-divider'}/>*/}
                        {/*        <div className={'m-a-delivery-price-row-space-between'}>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>*/}
                        {/*                {payList[0]?.dhlPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className={'m-a-delivery-price-row-space-between'}>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>*/}
                        {/*                {t(`deliveryFee`)}*/}
                        {/*            </div>*/}
                        {/*            <div className={'m-a-delivery-price-rowv-item'}>*/}
                        {/*                {payList[0]?.dhlAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className={'m-a-delivery-price-row-space-between'}>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item '}>*/}
                        {/*                {payList[0]?.dhlInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className={'m-a-delivery-price-row-space-between'}>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item primary'}>*/}
                        {/*                {totalDhlExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className={'m-a-delivery-price-row-space-between'}>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>*/}
                        {/*            <div className={'m-a-delivery-price-row-space-between-item font-c-progress font-b'}>*/}
                        {/*                {shipInfoList.outWayNum || ''}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                        {/*EMS*/}
                        {payList[0]?.ttEmsPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame'>
                                    <img className='m-a-delivery-price-delivery-agency' src={EmsLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.emsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalEmsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className="m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point" onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {payList[0]?.ttEmsPrePrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame'>
                                    <img className='m-a-delivery-price-delivery-agency' src={EmsLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsPrePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsPreAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.emsPreCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.emsPreInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalEmsPreExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className="m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point" onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*K-Packet*/}
                        {payList[0]?.ttKPackPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame'>
                                    <img className='m-a-delivery-price-delivery-agency'
                                         style={{width: "70px", height: "35px"}} src={kPacket} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.kpackPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.kpackAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.kpackCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.kpackInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalKpackExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*항공소형포장물*/}
                        {payList[0]?.ttAirSPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame' style={{padding: "3px"}}>
                                    <img className='m-a-delivery-price-delivery-agency' src={smallPacket} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modPlHeader3`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.airSPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.airSAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.airSCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.airSInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalAirSExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*선편*/}
                        {payList[0]?.ttSeaPrice > 0 && (
                            <div className={'m-a-delivery-price-add-content flex-start'}>
                                <div className='m-a-delivery-price-delivery-agency-frame' style={{padding: "3px"}}>
                                    <img className='m-a-delivery-price-delivery-agency' src={SeaShipLogo} alt={''}/>
                                </div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader6`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.seaPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`deliveryFee`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.seaAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`oTx1`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {payList[0]?.seaCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`insrFee`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item '}>
                                        {payList[0]?.seaInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div
                                        className={'m-a-delivery-price-row-space-between-item'}>{t(`modSHeader7`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item primary'}>
                                        {totalSeaExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`prodTrNum`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                        {/*국내배송*/}
                        {totalDomExpense > 0 && (
                            <div className={'m-a-delivery-price-add-content dt-price-flex-start'}>
                                <div className={'m-a-delivery-price-delivery-agency full'}>{t(`domesticTitle`)}</div>
                                <div className={'m-a-delivery-price-divider'}/>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>{t(`ttDmShipPr`)}</div>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {totalDomExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                                <div className={'m-a-delivery-price-row-space-between'}>
                                    <div className={'m-a-delivery-price-row-space-between-item'}>
                                        {t(`prodTrNum`)}
                                    </div>
                                    <div className={'m-a-delivery-price-row-space-between-item font-c-progress-b font-b c-point'} onClick={copyOutWayNum}>
                                        {shipInfoList.outWayNum || ''}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={'m-a-delivery-price-add-pay-frame'}>
                        <div className={'m-a-delivery-price-delivery-sub-title'}>{t(`modHeader10`)}</div>
                        {/*결제정보*/}
                        <div className={'m-a-delivery-price-divider'}/>

                        { payList[0]?.cardFee > 0 &&
                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3 m-b-10'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`bpmTx17`)}</div>
                            {/*국내카드수수료*/}
                            <div className={'m-a-delivery-price-row-space-between-item p-r-2'}>
                                <span>{payList[0]?.cardFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                            </div>
                        </div>
                        }

                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>{t(`myUseDep`)}</div>
                            {/*예치금사용*/}
                            <div className={'m-a-delivery-price-row-space-between-item p-r-2'}>
                                {payList[0]?.depUsePrice !== 0 ?
                                    <span>- {payList[0]?.depUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}
                            </div>
                        </div>
                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>
                                {t(`myUsePt`)}
                            </div>
                            <div className={'m-a-delivery-price-row-space-between-item p-r-2'}>
                                {payList[0]?.pointUsePrice !== 0 ?
                                    <span>- {payList[0]?.pointUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}
                            </div>
                        </div>
                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>
                                {t(`dpdCpNm`)}
                            </div>
                            <div className={'m-a-delivery-price-row-space-between-item p-l-2 p-r-2'}>
                                {payList[0]?.couponUsePrice !== 0 ?
                                    <span>- {payList[0]?.couponUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}
                            </div>
                        </div>
                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3'}>
                            <div className={'m-a-delivery-price-row-space-between-item'}>
                                {t(`appSale`)}
                            </div>
                            <div className={'m-a-delivery-price-row-space-between-item p-l-2 p-r-2'}>
                                {payList[0]?.appSalePrice !== 0 ?
                                    <span>- {payList[0]?.appSalePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}
                            </div>
                        </div>
                        <div className={'m-a-delivery-price-divider'}/>
                        <div className={'m-a-delivery-price-row-space-between p-l-3 p-r-3'}>
                            {/*최종결제금액*/}
                            <div className="m-a-delivery-price-delivery-sub-title">{t(`modFinalPay`)}
                                {payList[0]?.childFl ?
                                    <span className="font-s-12">({t(`epdHeader13`)})</span> : null}
                            </div>
                            <div className={'m-a-delivery-price-delivery-sub-title dt-price-primary p-r-2'}>
                                {payList[0]?.payStatus === "PS0" ? 0 : payList[0]?.lastPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  {payList[0]?.cardFee > 0 && payList[0]?.payStatus !== "PS0" &&
                                        <span style={{fontSize:"12px", color:"dimgray"}}>(+{payList[0]?.cardFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</span>
                                    }
                                {/*{payList[0]?.payStatus === "PS0"*/}
                                {/*    ? 0*/}
                                {/*    : [*/}
                                {/*        payList[0]?.depUsePrice || 0,*/}
                                {/*        payList[0]?.pointUsePrice || 0,*/}
                                {/*        payList[0]?.couponUsePrice || 0*/}
                                {/*    ]*/}
                                {/*        .reduce((sum, value) => sum + value, 0)*/}
                                {/*        .toString()*/}
                                {/*        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="m-a-delivery-price-detail-body">
                    <div className={'m-a-delivery-price-detail-table-title'}>
                        <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                        {t(`appReq`)} {/*적용요청사항*/}
                    </div>
                    <div className="wd-100pc display-flex flex-row ht-auto p-b-5">
                        <div className="m-a-delivery-price-req-label">{t(`reqOp`)}</div>
                        {/*요청옵션*/}
                        <div className="m-a-delivery-price-req-value">
                        {appReqList.tagRemove &&
                                <span style={{display: "flex"}}>- {t(`modReqCont1`)}</span>
                            }
                            {appReqList.shoesBoxRemove &&
                                <span style={{display: "flex"}}>- {t(`modReqCont2`)}</span>
                            }
                            {appReqList.hangerRemove &&
                                <span style={{display: "flex"}}>- {t(`modReqCont3`)}</span>
                            }
                            {appReqList.compressionPack &&
                                <span style={{display: "flex"}}>- {t(`modReqCont4`)}</span>
                            }
                            {appReqList.prodBoxRemove &&
                                <span style={{display: "flex"}}>- {t(`modReqCont5`)}</span>
                            }
                            {appReqList.packingHold &&
                                <span style={{display: "flex"}}>- {t(`modReqCont6`)}</span>
                            }
                            {appReqList.shipPriceDeposipay &&
                                <span style={{display: "flex"}}>- {t(`modReqCont7`)}</span>
                            }
                            {appReqList.shipPriceMessenger &&
                                <span style={{display: "flex"}}>- {t(`modReqCont8`)}</span>
                            }
                            {appReqList.cusPrepayFl &&
                                <span style={{display: "flex"}}>- {t(`oTx1`)}</span>
                            }
                        </div>
                    </div>
                    <div className="wd-100pc display-flex flex-row ht-auto">
                        <div className="m-a-delivery-price-req-label border-top-bt">{t(`modSmallMenu13`)}</div> {/*상세요청*/}
                        <div className="m-a-delivery-price-req-value border-top-bt">{appReqList.detailReq}</div>
                    </div>
                </div>
                <div className="m-a-delivery-price-detail-body">
                    <div className={'m-a-delivery-price-detail-table-title'}>
                        <img className={'m-a-delivery-price-detail-table-icon'} src={commonHether} alt={''}/>
                        {t(`packList`)} {/*패킹리스트*/}
                    </div>
                    <div className="m-a-delivery-price-add-packing-table p-b-5">
                        <div className="m-a-delivery-price-add-packing-table-row">
                            <div className={"m-a-delivery-price-add-packing-table-row-item sm"}/>
                            <div className={'m-a-delivery-price-add-packing-table-row-item lg label'}>
                                {t(`prodNm`)}</div>
                            <div className={'m-a-delivery-price-add-packing-table-row-item label'}>
                                {t(`prodOp`)}</div>
                            <div className={'m-a-delivery-price-add-packing-table-row-item label'}>
                                {t(`prodQy`)}</div>
                            <div className={'m-a-delivery-price-add-packing-table-row-item label'}>
                                {t(`prodPr`)}</div>
                        </div>
                        {packList && packList.map((pack, index) => (
                            <div className="m-a-delivery-price-add-packing-table-row" key={index}>
                                <div className={"m-a-delivery-price-add-packing-table-row-item sm"}>
                                    {index + 1}</div>
                                <div className="m-a-delivery-price-add-packing-table-row-item lg admin-tb-text-cut">
                                    {pack.name}</div>
                                <div className="m-a-delivery-price-add-packing-table-row-item admin-tb-text-cut">
                                    {pack.option}</div>
                                <div className={'m-a-delivery-price-add-packing-table-row-item'}>
                                    {pack.quantity?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                                <div className={'m-a-delivery-price-add-packing-table-row-item'}>
                                    {pack.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="pd12 wd-100pc">
                    {/*결제하기 버튼*/}
                    {pathComponent === "/UserMyPg" && (
                        <button className="admin-btn-C wd-100pc ht-45 font-s-13" onClick={() => setDeliveryDetailPayMove(true)}>{t(`payment`)}</button>
                    )}
                </div>
            </div>
            {
                deliveryDetailAddrSt ?
                    <MAddrBookPg
                        deliveryDetailAddrSt={deliveryDetailAddrSt}
                        deliveryDetailAddrFalseFn={deliveryDetailAddrFalseFn}
                        addrChoiceData={addrChoiceData}/>
                    :
                    deliveryDetailPayMove ?
                        <MsgSelectModal deliveryDetailPayMove={deliveryDetailPayMove}
                                        setDeliveryDetailPayMove={setDeliveryDetailPayMove}
                                        moveDeliveryPay={moveDeliveryPay}
                                        deliveryDetailPayMsg1={deliveryDetailPayMsg1}
                                        deliveryDetailPayMsg2={deliveryDetailPayMsg2}/>
                        :
                        isLoading ?
                            <CommonLoading/>
                            :
                            doneCopySt ?
                                <SaveMsgModal message={doneCopyMsg} />
                                :
                            null
            }
        </div>
    )
}

export default MDeliveryPriceDetail;
